import { Checkbox, CheckboxProps, Field, FieldProps } from '@hover/blueprint';
import React from 'react';
import { useFormContext } from 'react-hook-form';

interface CheckboxFieldProps
  extends Omit<FieldProps, 'size'>,
    Pick<CheckboxProps, 'size'> {
  ariaLabel: string;
}

const CheckboxField = ({
  ariaLabel,
  children,
  label,
  name,
  size = 'small',
  ...props
}: CheckboxFieldProps) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { errors, register } = useFormContext<Record<string, string>>();
  const error = errors[name]?.message;

  return (
    <Field {...props} error={error} label={label} name={name}>
      <Checkbox
        alignItems="baseline"
        aria-label={ariaLabel}
        id={`${name}-inner`}
        name={name}
        ref={register}
        size={size}
        sx={{
          // Note: this ensures Playwright can interact
          // with the input without passing `force: true`
          input: {
            zIndex: 1,
            opacity: 0,
            clip: 'unset !important',
          },
        }}
        type="checkbox"
      >
        {children}
      </Checkbox>
    </Field>
  );
};

export { CheckboxField };
